import React from "react";
import HandoversTable from "./components/HandoversTable";

export default function Handovers() {
  return (
    <div className="grid h-full min-h-0 grid-cols-1 gap-5">
      <HandoversTable />
    </div>
  );
}


